import React, { useEffect, useRef, useCallback } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CountUp } from 'countup.js';

import AboutImgOne from './../assets/images/about-img-1.jpg';
import AboutImgTwo from './../assets/images/about-img-2.jpg';

import AboutInfo from './AboutInfo';

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
    const counterRefs = useRef([]);
    const revealRefs = useRef([]);

    const addRevealRef = useCallback((el) => {
        if (el && !revealRefs.current.includes(el)) {
            revealRefs.current.push(el);
        }
    }, []);
    useEffect(() => {
        // CounterUp Alternative using CountUp.js
        counterRefs.current.forEach((el) => {
            const countUp = new CountUp(el, el.dataset.count, {
                duration: 15,
                scrollSpyDelay: 5,
                useEasing: true,
            });
            if (!countUp.error) {
                countUp.start();
            }
        });

        // GSAP Reveal Animation
        revealRefs.current.forEach((container) => {
            const image = container.querySelector('img');

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    toggleActions: 'play none none none',
                },
            });

            tl.set(container, { autoAlpha: 1 });

            tl.from(container, {
                // xPercent: -100,
                duration: 1,
                ease: 'power2.out',
            });

            tl.from(image, {
                xPercent: 100,
                scale: 1,
                delay: -1,
                duration: 1,
                ease: 'power2.out',
            });
        });
    }, []);
    const location = useLocation();
    const slug = location.pathname.replace(/^\/+/, '');
    let LinkText = '/about-us'
    let LinkBtn = 'Read More'
    if (slug === 'about-us'){
       LinkText = '/contact-us'
       LinkBtn = 'Connect Now'
    }
    return (
        <>
            {/* About Us Section Start */}
            <div className="about-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            {/* About Us Images Start */}
                            <div className="about-us-images">
                                {/* About Image 1 Start */}
                                <div className="about-img-1">
                                    <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }} >
                                      <img
  src={AboutImgOne}
  alt="Best Interior Design Company"
/>
                                    </figure>
                                </div>
                                {/* About Image 1 End */}
                                {/* About Image 2 Start */}
                                <div className="about-img-2">
                                    <figure className="image-anime reveal" ref={addRevealRef} style={{ opacity: 0 }} >
                                     <img
  src={AboutImgTwo}
  alt="Best Interior Design Company for Dream Homes"
/>
                                    </figure>
                                    {/* Feedback Counter Start */}
                                    <div className="experience-counter">
                                        <h3>
                                            <span className="counter" ref={(el) => (counterRefs.current[0] = el)} data-count="15">0</span>+
                                        </h3>
                                        <p>Years of experience</p>
                                    </div>
                                    {/* Feedback Counter End */}
                                </div>
                                {/* About Image 2 End */}
                                {/* Feedback Counter Start */}
                                <div className="feedback-counter">
                                    <p>
                                        <span className="counter" ref={(el) => (counterRefs.current[1] = el)} data-count="99">0</span>%
                                    </p>
                                    <h3>positive feedback</h3>
                                </div>
                                {/* Feedback Counter End */}
                            </div>
                            {/* About Us Images End */}
                        </div>
                        <div className="col-lg-6">
                            {/* About Us Content Start */}
                            <div className="about-us-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">about us</h3>
                                  <h2 className="text-anime-style-2" data-cursor="-opaque">
    Our Passion for Design, Your Vision Realized by an{' '}
    <span>Best Interior Design Company</span>
</h2>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s">
                                        Our dedicated team of designers works closely with you to
                                        understand your vision and bring it to life with thoughtful
                                        attention to detail. Whether it's transforming a single room or
                                        an entire home.
                                    </p>
                                </div>
                                {/* Section Title End */}
                                {/* About Us Content Body Start */}
                                <div className="about-us-content-body">
                                    {/* About Content Info Start */}
                                    <div className="about-us-content-info">
                                        {/* About Us Content List Start */}
                                        <div
                                            className="about-us-content-list wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <ul>
                                                <li>creative expertise</li>
                                                <li>client-centered approach</li>
                                            </ul>
                                        </div>
                                        {/* About Us Content List End */}
                                        {/* About Us Content Button Start */}
                                        <div
                                            className="about-us-content-btn wow fadeInUp"
                                            data-wow-delay="0.6s"
                                        >
                                            <Link to={LinkText} className="btn-default">
                                                {LinkBtn}
                                            </Link>
                                        </div>
                                        {/* About Us Content Button End */}
                                    </div>
                                    {/* About Content Info End */}
                                    {/* About Content List Start */}
                                    <div className="about-us-contact-list">
                                        {/* About Contact Item Start - Name First */}
                                        <div
                                            className="about-contact-item wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div className="icon-box">
                                                <i className="fa-solid fa-user" />
                                            </div>
                                            <div className="about-contact-content">
                                                <h3>Namita shende</h3>
                                                <p>Owner & Interior Designer</p>
                                            </div>
                                        </div>
                                        {/* About Contact Item End */}
                                        {/* About Contact Item Start - Phone Second */}
                                        <div
                                            className="about-contact-item wow fadeInUp"
                                            data-wow-delay="0.6s"
                                        >
                                            <div className="icon-box">
                                                <i className="fa-solid fa-phone" />
                                            </div>
                                            <div className="about-contact-content">
                                                <p>need any help?</p>
                                                <h3>+91 88302 19839</h3>
                                            </div>
                                        </div>
                                        {/* About Contact Item End */}
                                    </div>
                                    {/* About Content Info End */}
                                </div>
                                {/* About Us Content Body End */}
                            </div>
                            {/* About Us Content End */}
                        </div>
                        {(() => {
    if (slug === 'about-us') return <AboutInfo />;
    return null; // optional fallback
})()}
                        
                    </div>
                </div>
            </div>
            {/* About Us Section End */}
        </>
    )
}

export default AboutUs
